import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling
import './OpenGeospatialData.css';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom



function GeospatialOpenData() {
  const { t } = useTranslation(); // Hook for translation
  const data = t('openGeospatialData.data', { returnObjects: true });
  const doc = t('openGeospatialData.doc', { returnObjects: true });

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('GeospatialOpenData')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section 
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
         
          <p style={{ textAlign: 'justify' }}><b>{t('Description')}</b></p>
        
          <p style={{ textAlign: 'justify' }}>{t('Opendatadescription')}</p>
          <br/> <br/>
          <p style={{ textAlign: 'justify' }}><b>{t('UserResponsabiltyOpenData')}</b></p>

          <p style={{ textAlign: 'justify' }}>{t('UserResponsabiltyOpenData_P1')}</p>
          <p style={{ textAlign: 'justify' }}>{t('UserResponsabiltyOpenData_P2')}</p>
          <p style={{ textAlign: 'justify' }}>{t('UserResponsabiltyOpenData_P3')}</p>
          <p style={{ textAlign: 'justify' }}>{t('UserResponsabiltyOpenData_P4')}</p>
          <br/> <br/>
          <p style={{ textAlign: 'justify' }}><b>{t('GeosaResponsabiltyOpenData')}</b></p>

          <p style={{ textAlign: 'justify' }}>{t('GeosaResponsabiltyOpenData_P1')}</p>
          <p style={{ textAlign: 'justify' }}>{t('GeosaResponsabiltyOpenData_P2')}</p>
          <p style={{ textAlign: 'justify' }}>{t('GeosaResponsabiltyOpenData_P3')}</p>
          <p style={{ textAlign: 'justify' }}>{t('GeosaResponsabiltyOpenData_P4')}</p>
       
         
      </div> 
      </div>*/}
      
      <div className="cards-space" style={{height:"15vh"}}></div>
      {/*<section className="open-geospatial-container">
      <h1 className="open-geospatial-title">{t('GeospatialOpenData')}</h1></section>*/}
      <section >
      <div className="open-geospatial-grid">
        {data.map((data, index) => (
            <div className="data-card" key={index} id="opendata_todownload">
            <h2 className="data-card-title" style={{marginBottom:"0px"}} id="Opendata_item">{data.title}</h2>
            <div className="data-card-meta" id="Opendata_description">
              <p>
                <strong>{t('Description')}</strong> {data.description}
                
              </p>
              <p>
                <strong>{t('updated')}:</strong> {data.updated}
                
              </p>
             
            </div>
            <div className="data-card-actions" id="Opendata_format">
            <p style={{textAlign:"center", fontSize:"0.7rem"}}>
            <a href={data.shp_url} download>
        <button className="download-button" id="readMoreBtn">{t('SHP')}</button>
      </a>
      <a href={data.gpkg_url} download>
        <button className="download-button" id="readMoreBtn">{t('GPKG')}</button>
      </a>
      <a href={data.gdb_url} download>
        <button className="download-button" id="readMoreBtn">{t('GDB')}</button>
      </a>
      <a href={data.json_url} download={data.title} target="_blank" rel="noreferrer">
        <button className="download-button" id="readMoreBtn">{t('JSON')}</button>
      </a>    
     
              </p>
            </div>
          </div>
        ))}
        {doc.map((doc, index) => (
            <div className="data-card1" key={index} id="opendata_todisplay" >
            <h2 className="data-card-title" style={{marginBottom:"0px"}}>{doc.title}</h2>
            <div className="data-card-meta">
              <p>
                <strong>{t('Description')}</strong> {doc.description}
                
              </p>
              <p>
                <strong>{t('updated')}:</strong> {doc.updated}
                
              </p>
             
            </div>
            <div className="data-card-actions" style={{ justifyContent:"center"}} >
              
              <p style={{textAlign:"center", fontSize:"0.7rem", alignContent:"center"}}>
              <Link to={doc.url} rel="noopener noreferrer">
              
              <button className="download-button" id="Opendata_details">{t('read-more')}</button>
              </Link>
              </p>
            </div>
          </div>
        ))}
      </div>
      </section>
      <div className="cards-space" style={{height:"15vh"}}></div>
     
       
      
      
      

      

    </div>
);
}

export default GeospatialOpenData;
